import React from 'react';
import {SelectField, SelectInput} from 'react-admin';

const genders = [
  { id: 'READY', name: 'eDataStatus.READY' },
  { id: 'SYNCED',   name: 'eDataStatus.SYNCED' },
  { id: 'ERROR',   name: 'eDataStatus.ERROR' },
]

export const EDataStatusField = (props) => (
  <SelectField source={props.source} choices={genders} {...props} />
)

